import BackIcon from "../../../icons/back.icon";
import { BarcodeScanner } from "react-barcode-scanner";

interface IProps {
  setChooseOption: any;
  setShowScanMember: any;
}

export default function ScanMember({ setChooseOption, setShowScanMember }: IProps) {
  function handleBack() {
    setChooseOption(true);
    setShowScanMember(false);
  }

  return (
    <main className="relative w-full h-[50vh]">
      <section className="relative space-y-5">
        <div className="flex gap-3 items-center px-2">
          <button onClick={handleBack}>
            <BackIcon className="h-4 w-4" />
          </button>

          <p className="text-xl font-medium">Scan Member Code</p>
        </div>

        <BarcodeScanner
          onCapture={(barcode) => {
            console.log(barcode.rawValue);
          }}
          options={{
            formats: ["codabar", "qr_code", "ean_13", "ean_8", "itf", "unknown"],
          }}
        />
      </section>
    </main>
  );
}
